import { useState } from 'react';

import { TerminalPanel } from '../components/TerminalPanel';
import type { SSHConfig } from '../hooks/useTerminal';

export function TerminalPage() {
  const [mode, setMode] = useState<'local' | 'ssh'>('local');
  const [sshConfig, setSshConfig] = useState<SSHConfig>({
    host: 'localhost',
    port: 22,
    username: 'root',
  });
  const [showConfig, setShowConfig] = useState(false);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          gap: 8,
          padding: '12px 20px',
          background: '#161b22',
          borderBottom: '1px solid #30363d',
          alignItems: 'center',
        }}
      >
        <button
          onClick={() => {
            setMode('local');
            setShowConfig(false);
          }}
          style={{
            padding: '6px 14px',
            borderRadius: 6,
            border: '1px solid #30363d',
            fontSize: 12,
            background: mode === 'local' ? '#1f2937' : 'transparent',
            color: mode === 'local' ? '#58a6ff' : '#8b949e',
          }}
        >
          Local
        </button>
        <button
          onClick={() => setShowConfig(true)}
          style={{
            padding: '6px 14px',
            borderRadius: 6,
            border: '1px solid #30363d',
            fontSize: 12,
            background: mode === 'ssh' ? '#1f2937' : 'transparent',
            color: mode === 'ssh' ? '#58a6ff' : '#8b949e',
          }}
        >
          SSH
        </button>
      </div>

      {showConfig && mode === 'ssh' && (
        <div
          style={{
            padding: '12px 20px',
            background: '#0d1117',
            borderBottom: '1px solid #30363d',
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <input
            placeholder="Host"
            value={sshConfig.host}
            onChange={(e) => setSshConfig((p) => ({ ...p, host: e.target.value }))}
            style={inputStyle}
          />
          <input
            placeholder="Port"
            value={sshConfig.port}
            onChange={(e) => setSshConfig((p) => ({ ...p, port: parseInt(e.target.value) || 22 }))}
            style={{ ...inputStyle, width: 70 }}
          />
          <input
            placeholder="Username"
            value={sshConfig.username}
            onChange={(e) => setSshConfig((p) => ({ ...p, username: e.target.value }))}
            style={inputStyle}
          />
          <input
            placeholder="Password (optional)"
            type="password"
            value={sshConfig.password || ''}
            onChange={(e) => setSshConfig((p) => ({ ...p, password: e.target.value || undefined }))}
            style={inputStyle}
          />
          <button
            onClick={() => setMode('ssh')}
            style={{
              padding: '6px 16px',
              borderRadius: 6,
              border: 'none',
              background: '#238636',
              color: '#fff',
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Connect
          </button>
        </div>
      )}

      <div style={{ flex: 1 }}>
        <TerminalPanel mode={mode} sshConfig={mode === 'ssh' ? sshConfig : undefined} />
      </div>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  padding: '6px 10px',
  borderRadius: 6,
  border: '1px solid #30363d',
  background: '#0d1117',
  color: '#c9d1d9',
  fontSize: 12,
  outline: 'none',
  width: 140,
};
